import {
  getHeroContent,
  flagshipProducts,
  getFooterContent,
} from "./SolutionsPageContent";

class SolutionsPresenter {
  getHeroSectionContent() {
    return getHeroContent();
  }

  getFlagshipProducts() {
    return flagshipProducts; // Returns the array of product card data
  }

  getFooterContent() {
    return getFooterContent();
  }
}

export default SolutionsPresenter;
